import Header from 'ui/atoms/header';
import styled from 'styled-components';

export const RadioTooltipContainer = styled.div`
  position: relative;
  bottom: 0.75rem;
`;

export const RadioContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const LabelRadio = styled(Header)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1rem 0 0;
`;

export const InputSubtitle = styled(Header)`
  margin-bottom: 0.25rem;
`;

export const RuntimeDateContainer = styled.div`
  display: flex;
  width: 100%;
`;
